
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/name-domains",
      function () {
        return require("private-next-pages/name-domains/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/name-domains"])
      });
    }
  